export const colors = {
  primary: "#0f3c75",
  title: "#173a63",
  text: "#1f2937",
  muted: "#4b5563",
  lightText: "#64748b",
  border: "#dbe4f0",
  tableHeader: "#f1f5f9",
  panelBg: "#f8fbff",
  softButton: "#e2e8f0",
  dangerBg: "#fee2e2",
  dangerText: "#b91c1c",
};

export const cardStyle = {
  background: "#fff",
  borderRadius: "14px",
  padding: "22px",
  border: `1px solid ${colors.border}`,
  boxShadow: "0 2px 8px rgba(15,60,117,0.06)",
};

export const compactCardStyle = {
  background: "#fff",
  borderRadius: "14px",
  padding: "20px",
  border: `1px solid ${colors.border}`,
  boxShadow: "0 2px 8px rgba(15,60,117,0.06)",
};

export const pageTitleStyle = {
  color: colors.title,
  fontSize: "32px",
  fontWeight: 400,
  marginBottom: "8px",
};

export const pageSubtitleStyle = {
  color: colors.muted,
  fontSize: "16px",
};

export const sectionTitleStyle = {
  color: colors.title,
  fontSize: "22px",
  margin: 0,
};

export const primaryButtonStyle = {
  backgroundColor: colors.primary,
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  padding: "10px 14px",
  fontWeight: 600,
  cursor: "pointer",
  fontSize: "14px",
};

export const secondaryButtonStyle = {
  background: colors.softButton,
  border: "none",
  borderRadius: "8px",
  padding: "10px 14px",
  cursor: "pointer",
  fontWeight: 600,
};

export const dangerButtonStyle = {
  background: colors.dangerBg,
  color: colors.dangerText,
  border: "none",
  borderRadius: "8px",
  padding: "8px 12px",
  cursor: "pointer",
};

export const inputStyle = {
  padding: "12px",
  borderRadius: "8px",
  border: `1px solid #cbd5e1`,
  fontSize: "14px",
  outline: "none",
  width: "100%",
  boxSizing: "border-box",
};

export const searchInputStyle = {
  width: "100%",
  padding: "14px",
  borderRadius: "10px",
  border: "1px solid #cbd5e1",
  fontSize: "15px",
  marginBottom: "20px",
  outline: "none",
  boxSizing: "border-box",
};

export const emptyBoxStyle = {
  border: `1px solid ${colors.border}`,
  borderRadius: "12px",
  padding: "16px",
  backgroundColor: colors.panelBg,
  color: colors.muted,
};

export const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
};

export const tableHeaderRowStyle = {
  backgroundColor: colors.tableHeader,
  textAlign: "left",
};

export const thStyle = {
  padding: "14px",
};

export const tdStyle = {
  padding: "14px",
};

export const rowStyle = {
  borderTop: "1px solid #e2e8f0",
};